/* eslint-disable */
import { phoneSources } from '@ringcentral-integration/commons/enums/phoneSources';
export default {
  [phoneSources.account]: '帐户',
  [phoneSources.contact]: '联系人',
  [phoneSources.rcContact]: '{brand}',
  [phoneSources.lead]: '潜在客户',
  [phoneSources.opportunity]: '业务机会',
  [phoneSources.systemUser]: '系统用户',
};

// @key: @#@"[phoneSources.account]"@#@ @source: @#@"Account"@#@
// @key: @#@"[phoneSources.contact]"@#@ @source: @#@"Contact"@#@
// @key: @#@"[phoneSources.rcContact]"@#@ @source: @#@"{brand}"@#@
// @key: @#@"[phoneSources.lead]"@#@ @source: @#@"Lead"@#@
// @key: @#@"[phoneSources.opportunity]"@#@ @source: @#@"Opportunity"@#@
// @key: @#@"[phoneSources.systemUser]"@#@ @source: @#@"System User"@#@
